import React, { useCallback, useRef, useState, useMemo } from "react";
import cls from "./style.module.scss";
import ReturnOrderLayout from "../components/layout";
import useStyles from "isomorphic-style-loader/useStyles";
import { Iconfont } from "../../../../../../../../components/icon/iconfont";
import { fetchUploadImage, fetchTicketSend } from "../../../../../../../../../api";
import { useDispatch } from "react-redux";
import { setCustomerLoading } from "../../../../../../../../../store/actions/pages/customer";
import { BigButton } from "../../../../../../../../components/button";
import { IMAGE_GEEKO_LTD } from "../../../../../../../../../constants";
import { FormattedMessage, useIntl } from "react-intl";
import Alert from "../../../../../../../../components/alert";

const ReturnOrderMessage = props =>{
    useStyles(cls);
    const { onClose, returnList, orderId, setType, onRefresh, onEditor } = props;
    const loadImageCount = useRef(3);
    const dispatch = useDispatch();
    const Intl = useIntl();

    const [description, setDescription] = useState("");
    const [uploadedImages, setUploadedImages] = useState([]);

    const images = useMemo(() =>{
        return uploadedImages?.map(item=>item?.url);
    }, [uploadedImages]);

    const descriptionNum = useMemo(() => {
        if(!description){
            return 0
        } else {
            return 1000 - (description?.length || 0)
    }
    }, [description])

    const handleSubmit = useCallback(async () =>{
        let params = {
            orderId,
            items:[],
            description,
            customImages: images?.length > 0 ? images: null
        };

        let disposeItems = returnList.map(item=>({
            variantId: item.variantId,
            productId: item.productId,
            sku: item.sku,
            imageUrl: item.imageURL,
            reason: item.reason
        }));

        params.items = disposeItems;

        dispatch(setCustomerLoading(true));
        const fetchParams = { messageType: 1, message: JSON.stringify(params), operaId: orderId, questionType:'Return the order', questionTypeCode:'04' };
        let response = await fetchTicketSend(fetchParams);
        if(response?.code === 200){
            if(!!onRefresh){
                await onRefresh();
            }
            onClose('refresh');
            setType(0);
            onEditor(fetchParams);
        }else{
            response?.result && Alert(response.result);
        }
        dispatch(setCustomerLoading(false));
    }, [returnList, description, images, orderId]);

    const removeImage = useCallback((index) =>{
        let receiptFiles = [...uploadedImages];
        receiptFiles?.splice(index, 1);
        setUploadedImages(receiptFiles);
    }, [uploadedImages]);

    const loadImage = useCallback(async (evt) =>{
        if(!(evt.target.files?.length > 0)){
            return;
        }
        dispatch(setCustomerLoading(true));
        let formData = new FormData();
        formData.append("type","return_order");
       
        let files = Array.from(evt.target.files);
        files?.forEach(file =>{
            formData.append("files", new File([file], file?.name));
        });
        
        let response = await fetchUploadImage(formData, { 'Content-Type': 'application/x-www-form-urlencoded' });
        if(response?.code === 200 && response?.result){
            const { result } = response;
            setUploadedImages(state=>{
                let images = [...state, ...result].slice(0, loadImageCount.current);
                return images;
            });
        }
        dispatch(setCustomerLoading(false));
    }, []);

    return <ReturnOrderLayout
        topSlot={<span><FormattedMessage id="please_submit_further_details" defaultMessage="Please submit further details" /></span>} 
        bottomSlot={<BigButton onClick={()=>handleSubmit(returnList)}><FormattedMessage id="submit" defaultMessage="Submit" /></BigButton>} 
        onClose={onClose} 
    >
        <div className={cls.ReturnOrderMessage}>
            <div className={cls.Description}>
                <div className={cls.Title}><FormattedMessage id="description" defaultMessage="Description" /></div>

                <div className={`${cls.DesInputBox}`}>
                    <textarea
                        maxLength="1000"
                        name="description"
                        placeholder={`${Intl.formatMessage({ id: "descrive_problem_customer_service_respond", defaultMessage: "Please describe your problem as much as possible so that customer service can respond faster" })}...`}
                        onChange={e =>setDescription(e.target.value)}>
                    </textarea>

                    <span className={cls.DescriptionNum}>{descriptionNum}/1000</span>
                </div>
            </div>

            <div className={cls.UploadImageContainer}>
                <p className={cls.Title}><FormattedMessage id="upload_image" defaultMessage="Upload Image" /></p>

                <p className={cls.Message}><FormattedMessage id="image_formate" defaultMessage="Maximum of 3 photos, only JPEG, GIF or PNG." /></p>

                <div className={cls.Container}>
                    {
                        images?.map((image, index) =>(
                            <div key={image+index} className={cls.ImageItem}>
                                <img src={`${IMAGE_GEEKO_LTD}${image}`} alt="IMAGE" />
                                <span className={cls.RemoveImg} onClick={() =>removeImage(index)}>&times;</span>
                            </div>
                        ))
                    }

                    {
                        ((!images?.length) || (images?.length < loadImageCount.current)) && <div className={cls.UploadImage}>
                            <form>
                                <input 
                                    type="file" 
                                    name="imageFiles" 
                                    multiple="multiple" 
                                    onChange={(e) =>loadImage(e)} 
                                    accept="image/jpg,image/jpeg,image/png,image/gif"
                                />
                            </form>

                            <Iconfont className={cls.Icon}>&#xe68c;</Iconfont>

                            <span className={cls.Num}>{images?.length || 0} / {loadImageCount.current}</span>
                        </div>
                    }
                </div>
                
            </div>
        </div>
    </ReturnOrderLayout>
}

export default ReturnOrderMessage;